export default __webpack_public_path__ + "static/media/DAIF_Intro_Play_Video.cdb941c6.mp4";